import { Phone, EnvelopeSimple, MapPin } from "@phosphor-icons/react";

export default function Footer({ t }) {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="footer"
      className="border-t border-white/10 py-12"
      style={{ background: "#050505" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          {/* Brand */}
          <div>
            <span className="font-outfit font-bold text-2xl tracking-[0.15em] text-white block mb-3">
              ETRADE
            </span>
            <p className="text-sm text-[#94A3B8] font-chivo leading-relaxed max-w-xs">
              ETRADE d.o.o. — {t.contact.address.includes("Slovenija") ? "Vas zaupanja vreden IT partner." : "Your trusted IT partner."}
            </p>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-outfit font-semibold mb-4 text-sm uppercase tracking-wider">
              {t.contact.title}
            </h4>
            <div className="flex flex-col gap-3">
              <a href={`tel:${t.contact.phone.replace(/\s/g, "")}`} className="flex items-center gap-2 text-sm text-[#94A3B8] hover:text-[#00F0FF] transition-colors font-chivo" data-testid="footer-phone">
                <Phone size={16} weight="duotone" className="text-[#00F0FF]" />
                {t.contact.phone}
              </a>
              <a href={`mailto:${t.contact.email}`} className="flex items-center gap-2 text-sm text-[#94A3B8] hover:text-[#00F0FF] transition-colors font-chivo" data-testid="footer-email">
                <EnvelopeSimple size={16} weight="duotone" className="text-[#00F0FF]" />
                {t.contact.email}
              </a>
              <div className="flex items-center gap-2 text-sm text-[#94A3B8] font-chivo" data-testid="footer-address">
                <MapPin size={16} weight="duotone" className="text-[#00F0FF] flex-shrink-0" />
                {t.contact.address}
              </div>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-outfit font-semibold mb-4 text-sm uppercase tracking-wider">
              Links
            </h4>
            <div className="flex flex-col gap-3">
              {[
                { label: t.nav.services, href: "#services" },
                { label: t.nav.about, href: "#about" },
                { label: t.nav.contact, href: "#contact" },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(link.href)?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="text-sm text-[#94A3B8] hover:text-[#00F0FF] transition-colors font-chivo"
                  data-testid={`footer-link-${link.href.slice(1)}`}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#94A3B8] font-chivo">
            &copy; {year} ETRADE d.o.o. {t.footer.rights}
          </p>
          <div className="flex gap-6">
            <button className="text-xs text-[#94A3B8] hover:text-[#00F0FF] transition-colors font-chivo" data-testid="footer-privacy">
              {t.footer.privacy}
            </button>
            <button className="text-xs text-[#94A3B8] hover:text-[#00F0FF] transition-colors font-chivo" data-testid="footer-terms">
              {t.footer.terms}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
